export default "__VITE_ASSET__CVUvJSz7__"